import type { ComponentProps, ReactElement } from 'react';
import { Component, createRef } from 'react';
import type { InputFormState } from '../../utils/form';
import { InputText } from '../InputText';
import styles from './styles.module.css';

type InputProps = ComponentProps<'input'>;

export interface InputPasswordProps {
  name: string;
  id?: string;
  state?: InputFormState;
  value?: string;
  disabled?: boolean;
  onChange: InputProps['onChange'];
  onBlur?: InputProps['onBlur'];
  onFocus?: InputProps['onFocus'];
}

interface InputPasswordState {
  type: 'password' | 'text';
}

/** @deprecated use InputPassword from kitt-universal instead */
export class InputPassword extends Component<InputPasswordProps, InputPasswordState> {
  static defaultProps = {
    value: '',
  };

  state: InputPasswordState = { type: 'password' };

  passwordInputRef = createRef<HTMLInputElement>();

  componentDidUpdate(prevProps: InputPasswordProps, prevState: InputPasswordState): void {
    if (prevState.type !== this.state.type && this.passwordInputRef.current) {
      this.passwordInputRef.current.focus();
    }
  }

  togglePassword = (): void => {
    this.setState((state) => ({
      type: state.type === 'password' ? 'text' : 'password',
    }));
  };

  render(): ReactElement {
    return (
      <div className={styles.InputPasswordContainer}>
        <InputText
          ref={this.passwordInputRef}
          type={this.state.type}
          value={this.props.value}
          name={this.props.name}
          id={this.props.id}
          icon={this.state.type === 'password' ? 'eye' : 'eye-off'}
          state={this.props.state}
          disabled={this.props.disabled}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
          onFocus={this.props.onFocus}
          onIconClicked={this.togglePassword}
        />
      </div>
    );
  }
}
